import { doRequest, doMultipleRequest } from '../../api/index';

const state = {
  availableEvents: [],
  news: {
    latestNews: [],
    mostViewed: [],
    featured: [],
    list: {
      best: {},
      latest: {}
    },
    latestFeatured: null
  }
};

const getters = {
  latestNews(s) {
    return s.news.latestNews;
  },
  mostViewedNews(s) {
    return s.news.mostViewed;
  },
  featuredNews(s) {
    return s.news.featured;
  },
  latestFeaturedNews(s) {
    return s.news.latestFeatured;
  },
  availableEvents(s) {
    return s.availableEvents;
  }
};

const actions = {
  loadSidePanelNews({ commit }, args) {
    return doMultipleRequest(['news.list', 'news.mostViewed'], args)
      .then((data) => {
        commit('setSidePanelNewsData', data);
      });
  },
  loadFeaturedNews({ commit }, args) {
    return doMultipleRequest(['news.featured', 'news.latestFeatured'], args)
      .then((data) => {
        commit('setFeaturedNews', data);
      });
  },
  loadAvailableEvents({ commit }, args) {
    return doRequest('events.availableEvents', args)
      .then((data) => {
        commit('setAvailableEvents', data);
      });
  }
};

const mutations = {
  setSidePanelNewsData(s, data) {
    data.forEach((item) => {
      if (item.restName === 'list') {
        s.news.latestNews = item.data;
      } else if (item.restName === 'mostViewed') {
        s.news.mostViewed = item.data;
      }
    });
  },
  setFeaturedNews(s, data) {
    data.forEach((item) => {
      if (item.restName === 'featured') {
        s.news.featured = item.data;
      } else if (item.restName === 'latestFeatured') {
        s.news.latestFeatured = item.data;
      }
    });
  },
  setAvailableEvents(s, data) {
    s.availableEvents = data;
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
};
